var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.676 77.338C154.676 120.05 120.051 154.676 77.339 154.676C34.625 154.676 0 120.05 0 77.338C0 34.625 34.625 0 77.339 0C120.051 0 154.676 34.625 154.676 77.338Z",
    fill: "#62A5A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.981 79.477C133.981 110.759 107.255 131.843 77.5691 131.843C47.8821 131.843 20.6951 110.759 20.6951 79.477C20.6951 48.192 46.0531 22.833 77.3381 22.833C108.619 22.833 133.981 48.192 133.981 79.477Z",
    fill: "#EA692B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8721 55.001C70.8721 63.845 63.7011 71.016 54.8581 71.016C46.0121 71.016 38.842 63.846 38.842 55.001C38.842 46.155 46.0121 38.986 54.8581 38.986C63.7011 38.987 70.8721 46.156 70.8721 55.001Z",
    fill: "#E39335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.468 55.001C64.468 60.308 60.165 64.609 54.859 64.609C49.551 64.609 45.249 60.308 45.249 55.001C45.249 49.693 49.552 45.392 54.859 45.392C60.165 45.392 64.468 49.694 64.468 55.001Z",
    fill: "#8A603C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5751 55.001C82.5751 63.845 89.7471 71.016 98.5891 71.016C107.436 71.016 114.605 63.846 114.605 55.001C114.605 46.155 107.436 38.986 98.5891 38.986C89.7471 38.987 82.5751 46.156 82.5751 55.001Z",
    fill: "#E39335"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9821 55.001C88.9821 60.308 93.2851 64.609 98.5891 64.609C103.898 64.609 108.2 60.308 108.2 55.001C108.2 49.693 103.897 45.392 98.5891 45.392C93.2841 45.392 88.9821 49.694 88.9821 55.001Z",
    fill: "#8A603C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.458 80.244C104.723 56.359 97.5161 49.915 76.9971 49.915C76.9051 49.915 76.814 49.918 76.725 49.918C76.634 49.918 76.544 49.915 76.453 49.915C55.933 49.915 48.7251 56.359 43.9911 80.244C36.8901 89.721 37.9401 118.605 75.0931 118.605C75.6451 118.605 76.186 118.6 76.725 118.592C77.262 118.6 77.804 118.605 78.357 118.605C115.51 118.605 116.559 89.721 109.458 80.244Z",
    fill: "#E39335"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_976",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 47,
    width: 73,
    height: 72
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.458 79.08C104.723 54.471 97.5161 47.832 76.9971 47.832C76.9051 47.832 76.814 47.835 76.725 47.836C76.634 47.835 76.544 47.832 76.453 47.832C55.933 47.832 48.7251 54.472 43.9911 79.08C36.8901 88.845 37.9401 118.605 75.0931 118.605C75.6451 118.605 76.186 118.6 76.725 118.592C77.262 118.6 77.804 118.605 78.357 118.605C115.51 118.605 116.559 88.845 109.458 79.08Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.481 126.994C118.481 144.683 101.237 159.023 77.0771 159.023C52.9161 159.023 35.6721 144.683 35.6721 126.994C35.6721 109.305 52.9161 89.105 77.0771 89.105C101.237 89.106 118.481 109.305 118.481 126.994Z",
    fill: "#F3DBBD"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8691 76.931C65.8691 80.414 63.0461 83.237 59.5631 83.237C56.0791 83.237 53.2542 80.414 53.2542 76.931C53.2542 73.447 56.0781 70.622 59.5631 70.622C63.0461 70.621 65.8691 73.447 65.8691 76.931Z",
    fill: "#8A603C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7561 76.984C62.7561 78.747 61.3261 80.175 59.5641 80.175C57.8011 80.175 56.3711 78.746 56.3711 76.984C56.3711 75.221 57.8021 73.791 59.5641 73.791C61.3261 73.79 62.7561 75.221 62.7561 76.984Z",
    fill: "#3B3E43"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2802 74.475C60.2802 75.401 59.5311 76.151 58.6041 76.151C57.6791 76.151 56.9281 75.402 56.9281 74.475C56.9281 73.548 57.6791 72.798 58.6041 72.798C59.5311 72.798 60.2802 73.549 60.2802 74.475Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1621 91.604C85.1621 94.525 81.7521 96.991 77.5461 96.991C73.3381 96.991 69.9281 94.526 69.9281 91.604C69.9281 88.682 73.3381 86.314 77.5461 86.314C81.7521 86.314 85.1621 88.682 85.1621 91.604Z",
    fill: "#3B3E43"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6051 107.1C67.5151 107.1 65.2011 106.07 62.6971 104.02C62.3631 103.747 62.3131 103.255 62.5871 102.921C62.8591 102.587 63.3521 102.537 63.6871 102.811C66.6161 105.208 69.1401 106.029 71.1871 105.25C75.2631 103.699 76.4701 96.404 76.4811 96.33C76.5491 95.904 76.9511 95.611 77.3771 95.682C77.8031 95.749 78.0931 96.149 78.0251 96.575C77.9701 96.912 76.6561 104.842 71.7421 106.711C71.0571 106.971 70.3441 107.1 69.6051 107.1Z",
    fill: "#3B3E43"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1082 107.786C83.4622 107.786 82.8421 107.667 82.2541 107.431C77.5821 105.561 76.7061 96.896 76.6701 96.528C76.6291 96.099 76.9431 95.717 77.3741 95.676C77.8031 95.633 78.1871 95.951 78.2261 96.38C78.4411 98.625 79.6901 104.724 82.8331 105.982C84.5611 106.673 86.7591 105.873 89.3711 103.609C89.6971 103.325 90.1901 103.36 90.4731 103.686C90.7561 104.012 90.7201 104.506 90.3961 104.788C88.0931 106.782 85.9882 107.786 84.1082 107.786Z",
    fill: "#3B3E43"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.506 90.019C82.326 90.72 81.289 91.06 80.186 90.779C79.08 90.499 78.3301 89.704 78.5071 89.003C78.6881 88.302 79.725 87.961 80.829 88.242C81.934 88.524 82.685 89.318 82.506 90.019Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5781 76.931C87.5781 80.414 90.4011 83.237 93.8851 83.237C97.3691 83.237 100.194 80.414 100.194 76.931C100.194 73.447 97.3691 70.622 93.8851 70.622C90.4011 70.622 87.5781 73.447 87.5781 76.931Z",
    fill: "#8A603C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6941 76.984C90.6941 78.747 92.1241 80.175 93.8851 80.175C95.6491 80.175 97.0781 78.746 97.0781 76.984C97.0781 75.221 95.6481 73.791 93.8851 73.791C92.1231 73.79 90.6941 75.221 90.6941 76.984Z",
    fill: "#3B3E43"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.167 74.475C93.167 75.401 93.917 76.151 94.844 76.151C95.768 76.151 96.521 75.402 96.521 74.475C96.521 73.548 95.768 72.798 94.844 72.798C93.917 72.798 93.167 73.549 93.167 74.475Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9192 93.893C61.9192 93.893 53.3742 88.494 29.8562 88.049",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8301 96.426C60.8301 96.426 50.7721 93.008 27.6101 97.381",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7371 99.424C60.7371 99.424 49.8811 97.951 28.2921 106.364",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.321 94.675C92.321 94.675 100.866 89.276 124.384 88.829",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.41 97.206C93.41 97.206 103.468 93.788 126.63 98.162",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5031 100.205C93.5031 100.205 104.358 98.731 125.947 107.145",
    stroke: "#3D342F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.75e9cf3b7fa6dfaf1e8038b41baad830.svg";
export { ForwardRef as ReactComponent };